/**
 * Admin panel helper functions for displaying designer/company information in event management
 * Used in FD100CompilationJury, FDProjetsList, and JuryProfile components
 */

/**
 * Get the display name for a designer/company in admin event panels
 * Handles override names, person vs company display, and proper casing
 * 
 * @param {Object} project - The project object containing override_designer_name, candidate_as_person_fd100_25
 * @param {Object} user - The user object containing hsProfile and hsCompany data
 * @returns {string} The formatted display name
 */
export function getEventDesignerDisplayName(project, user) {
    // First priority: admin override name
    if (project.override_designer_name) {
        return project.override_designer_name.toUpperCase();
    }
    
    // Second priority: check if candidating as person for FD100
    if (project.candidate_as_person_fd100_25 === "oui") {
        const firstName = user.hsProfile?.firstname || '';
        const lastName = user.hsProfile?.lastname || '';
        return `${firstName} ${lastName}`.trim().toUpperCase();
    }
    
    // Default: company name in uppercase
    return user.hsCompany?.properties?.name?.toUpperCase() || '';
}

/**
 * Get the profile link for a designer/company in admin event panels
 * Handles override links and person vs company links
 * 
 * @param {Object} project - The project object containing override_designer_link, candidate_as_person_fd100_25
 * @param {Object} user - The user object containing email and company data
 * @returns {string} The profile link URL
 */
export function getEventDesignerProfileLink(project, user) {
    // First priority: admin override link
    if (project.override_designer_link) {
        return project.override_designer_link;
    }
    
    // Second priority: check if candidating as person for FD100
    if (project.candidate_as_person_fd100_25 === "oui") {
        return `/profile?id=${btoa(user.user?.email || user.email)}`;
    }
    
    // Default: company profile link
    return `/company?id=${user.company?._id}`;
}